import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Sidebar from "../components/dashboard/Sidebar";
import ContentArea from "../components/dashboard/ContentArea";
import {
  loadFonts,
  loadUserDetails,
  loadUserTemplates,
} from "../thunks/dashboardThunks";
import UserProfileModal from "./Profile";
import {
  closeProfileModal,
  selectIsProfileModalOpen,
} from "../store/common/profileModalSlice";
import { loadFont } from "../utils";

const Dashboard = () => {
  const dispatch = useDispatch();
  const isProfileModalOpen = useSelector(selectIsProfileModalOpen);
  const fontList = useSelector((state) => state.fonts);

  const { userTemplates } = useSelector((state) => state.templates);

  const handleCloseModal = () => {
    dispatch(closeProfileModal());
  };

  const resolveFonts = async () => {
    return Promise.all(
      fontList.map((font) => loadFont(font.name, font.fontFile))
    );
  };

  useEffect(() => {
    if (fontList.length) {
      resolveFonts();
    }
  }, [fontList]);

  useEffect(() => {
    dispatch(loadFonts());
    if (!(userTemplates || []).length) {
      dispatch(loadUserTemplates(0, "", 4));
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(loadUserDetails());
  }, []);

  return (
    <div className="flex">
      <Sidebar />
      <ContentArea isDashboard />
      {isProfileModalOpen && <UserProfileModal onClose={handleCloseModal} />}
    </div>
  );
};

export default Dashboard;
